<template>
    <el-drawer :title="`${formData.id ? '编辑' : '创建'}标签`" :visible.sync="drawerShow" :wrapperClosable="false"
        :destroy-on-close="true" size="auto" @close="close">
        <div class="drawer-content">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">

                <el-form-item label="当前演出：">
                    {{activityName}}
                </el-form-item>
                <el-form-item prop="name" label="标签名称：">
                    <el-input v-model="formData.name" :maxlength="10" show-word-limit></el-input>
                </el-form-item>
                <el-form-item prop="sort" label="序号：">
                    <el-input-number style="width:100%" :precision="0" v-model="formData.sort" :min="1"
                        :max="99999999"></el-input-number>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>
<script>
const defaultData = {
    activityId: "",
    id: "",
    name: "",
    sort: 1,
    status: 1
}
export default {
    props: {
        activityId: {
            type: [String, Number],
            default: ""
        },
        activityName: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            formData: {
                ...defaultData
            },
            rules: {
                name: [{ required: true, message: "请填写标签名称" }]
            }
        }
    },
    methods: {
        close() {
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData
            }
        },
        show(data) {
            this.formData = {
                ...defaultData,
                ...data,
                activityId: this.activityId
            };
            this.drawerShow = true;
        },
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/photo/saveTags',
                        data: {
                            ...this.formData,
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>